import * as shallowEqual from 'shallowequal';
import {connect} from 'react-redux';
import {sendScreen, confirmSendScreenError} from '../../redux/modules/video/actions';
import {toggleLeftBar} from '../../redux/session/actions';
import {IStore} from '../../redux/session/reducers';
import {SessionUi, ISessionConnected, ISessionProps} from './session-ui';
import {
    showRunCodeHintSelector,
    showRunCodeHintAcknowledgedSelector,
    linkSelector
} from '../../redux/session/selectors';

const mapStateToProps = (state: IStore): ISessionConnected => ({
    showRunCodeHintAcknowledged: showRunCodeHintAcknowledgedSelector(state),
    showConsoleScrollHint: state.session.showConsoleScrollHint,
    webSocketConnected: state.webSocket.connected,
    hadTestsUnlocked: state.session.hadTestsUnlocked,
    showRunCodeHint: showRunCodeHintSelector(state),
    showVideoHint: state.session.showVideoHint,
    leftBarHidden: state.splitPane.leftBarHidden,
    interviewType: state.session.interviewType,
    isInterviewer: state.session.isInterviewer,
    dashboardUrl: state.session.dashboardUrl,
    initialCode: state.session.code.initial,
    challenge: state.session.challenge,
    language: state.session.code.language,
    hasTests: state.session.code.hasTests,
    running: state.console.running,
    link: linkSelector(state),
    startTime: state.session.startTime,
    isSendingScreen: state.video.isSendingScreen,
    sendScreenError: state.video.sendScreenError,
    room: state.video.room,
});

const mapDispatchToProps = {
    toggleLeftBar,
    sendScreen,
    confirmSendScreenError,
};

const options = {
    areStatePropsEqual: (prevProps: ISessionProps, nextProps: ISessionProps) => (
        /**
         * Skip re-render after the `showConsoleScrollHint` property has been changed
         */
        prevProps.showConsoleScrollHint !== nextProps.showConsoleScrollHint
            || shallowEqual(prevProps, nextProps)
    ),
};

export const SessionContainer = connect<ISessionProps, any, any>(
    mapStateToProps,
    mapDispatchToProps,
    null,
    options,
)(SessionUi);
